import { generateBreadcrumbs } from '@bv/utils/route/breadcrumbs/generate-breadcrumbs';

const dashboardBreadcrumbs = generateBreadcrumbs({
  label: 'GLOBAL.NAVS.DASHBOARD',
  route: { name: 'dashboard' },
});

const dashboard_routes = [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('./DashboardView.vue'),
    meta: {
      permissions: 'read-dashboard',
      breadcrumbs: dashboardBreadcrumbs(),
      header: {
        title: 'GLOBAL.NAVS.DASHBOARD',
        icon: 'bvi-performance-speedometer-square',
      },
    },
  },
];

export default dashboard_routes;
